import { getJson, setJson } from 'shared-base';
import { Json } from '../types';

const STORAGE_KEY = 'settings';

let settingsData: Json = {};

const defaultValue = {
  highQuality: true,
  darkEditor: true,
  autoTexture: false,
  showUvCheckers: false,
};

const save = () => {
  setJson(STORAGE_KEY, settingsData);
};

const restore = () => {
  settingsData = getJson(STORAGE_KEY) ?? {
    ...defaultValue,
  };
};

export namespace settings {
  export const bootstrap = () => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setJson(STORAGE_KEY, defaultValue);
    }
    restore();
  };

  export const getAll = () => {
    return Promise.resolve({ data: settingsData });
  };

  export const patch = (data: any) => {
    settingsData = { ...settingsData, ...data };
    save();
    return Promise.resolve({ data: settingsData });
  };
}
